import { put, take, select, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { push } from 'react-router-redux';

import * as actions from 'actions';
import * as selectors from 'selectors';
import * as api from 'api';

export function* watchForMailQueryChange() {

  while(true) { // eslint-disable-line no-constant-condition
    const { payload } = yield take('@@router/LOCATION_CHANGE');

    const isThreadsList = ['/messages', '/messages/'].indexOf(payload.pathname) >= 0;

    if(isThreadsList) {
      let page = 1;

      if(payload.action === 'POP') {
        const paging = yield select(selectors.getMailPaging, 'mailThreads');
        page = paging.page;
      }

      yield put(actions.mailThreadsFetch(page));
    }
  }
}

export function* watchForSentTeamMessage() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take(actions.MAIL_MESSAGE_THE_TEAM_SUCCESS);
    yield put(push('/messages'));
  }
}

export function* watchForSentThreadMessage() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.MAIL_THREAD_MESSAGE_CREATE_SUCCESS);

    yield put(actions.mailThreadMessagesFetch(action.threadId));
    yield put(actions.mailThreadMessageEditingReset(''));
  }
}

export function* refreshMail() {
  const routing = yield select(state => state.routing);
  const pathname = routing.locationBeforeTransitions.pathname;
  let entitiesType = null;
  let action =  null;

  if(pathname.indexOf('/messages/threads/') >= 0) {
    const threadId = Number(pathname.slice(pathname.lastIndexOf('/') + 1));
    action = actions.mailThreadMessagesFetch(threadId);
    entitiesType = 'mailThreadMessages';
  }
  else if(pathname === '/messages') {
    action = actions.mailThreadsFetch();
    entitiesType = 'mailThreads';
  }

  if(entitiesType) {
    const paging = yield select(selectors.getMailPaging, entitiesType);

    if(paging.page == 1) {
      yield put(action);
    }
  }
}

export default function* (socket, request) {
  yield [
    fork(takeLatest, actions.MAIL_THREADS_FETCH, request(api.mailThreadsFetch, 'page')),
    fork(takeLatest, actions.MAIL_THREAD_MESSAGES_FETCH, request(api.mailThreadMessagesFetch, 'threadId', 'page')),
    fork(takeLatest, actions.MAIL_MESSAGE_THE_TEAM, request(api.mailMessageTheTeam, 'text')),
    fork(takeLatest, actions.MAIL_THREAD_MESSAGE_UPDATE, request(api.mailThreadMessageUpdate, 'threadId', 'threadMessageId', 'updates')),
    fork(takeLatest, actions.MAIL_THREAD_MESSAGE_CREATE, request(api.mailThreadMessageCreate, 'threadId', 'text')),
    fork(watchForSentTeamMessage),
    fork(watchForSentThreadMessage),
    fork(watchForMailQueryChange)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/sagas.js
 **/